// extracted by mini-css-extract-plugin
export var blog = "styles-module--blog--009fb";
export var buttons = "styles-module--buttons--8f47a";
export var container = "styles-module--container--8bca2";
export var container__mobile = "styles-module--container__mobile--89d7e";
export var header = "styles-module--header--ce025";
export var nextButton = "styles-module--next-button--c6869";
export var prevButton = "styles-module--prev-button--7ab07";
export var products__mobile = "styles-module--products__mobile--ad74f";
export var title = "styles-module--title--abbf7";